import React, { MouseEventHandler, useState } from "react";
import cn from "classnames";
import styled from "styled-components";
import { useAppSelector } from "src/store/actions/action";
import { shallowEqual } from "react-redux";

interface IProcessProps {
  onClick?: MouseEventHandler<HTMLButtonElement> | any;
}

const FulfillProcessItem = (props: IProcessProps) => {
  const example = [
    {
      code: "U",
      name: "수정",
    },
    {
      code: "D",
      name: "삭제",
    },
  ];

  return (
    <>
      {example.map((v, i) => {
        return (
          <li key={i}>
            <ProcessItemSet
              onClick={() => {
                props.onClick!(v.code);
              }}
            >
              {v.name}
            </ProcessItemSet>
          </li>
        );
      })}
    </>
  );
};

const ProcessItemSet = styled.button`
  width: 100%;
  padding: 30px 0;
  border: none;
  background: none;
  color: #7f7f7f;
  font-size: 25px;
  font-family: "Roboto";
`;

export default FulfillProcessItem;
